export default __webpack_public_path__ + "static/media/logo-circle.a88d415c.svg";